<div [@fadeIn] class="relative">
    <div class="relative flex items-start justify-center  bg-[#f8fafdff] px-[64px] py-[40px] overflow-hidden " >
        <!-- Centered Content Container -->
        <div class="flex flex-col items-center justify-center gap-[40px] w-full max-w-[600px]">
            <!-- Icon Section -->
            <div class="flex flex-col items-center gap-[24px]">
                <div class="w-[120px] h-[120px] rounded-full bg-red-50 flex items-center justify-center">
                    <!-- Network Error Icon -->
                    <svg *ngIf="errorType === 'network'" class="w-[64px] h-[64px] text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 9.238a9 9 0 01-5.656-2.343m0 0l-2.829-2.829m2.829 2.829L3 21"></path>
                    </svg>
                    <!-- Server/Unknown Error Icon -->
                    <svg *ngIf="errorType !== 'network'" class="w-[64px] h-[64px] text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                    </svg>
                </div>
            </div>
    
            <!-- Error Message Section -->
            <div class="flex flex-col items-center gap-[16px] w-full text-center">
                <h1 class="text-[#111215ff] font-bold font-['archivo'] text-[32px] leading-[42px] tracking-[1.5%]">
                    {{ errorType === 'network' ? 'Connection Error' : errorType === 'server' ? 'Server Error' : 'Something Went Wrong' }}
                </h1>
                <p class="text-[#444955] font-['archivo'] text-[20px] leading-[29px] max-w-[500px]">
                    {{ errorMessage }}
                </p>
            </div>
    
            <!-- Action Buttons -->
            <div class="flex flex-col items-center gap-[16px] w-full">
                <NiButton 
                    [label]="isRetrying ? 'Retrying...' : 'Try Again'" 
                    [loading]="isRetrying"
                    [loadingText]="'Retrying...'"
                    bg="primary-500"
                    text="white"
                    hoverBg="primary-600"
                    px="[24px]"
                    py="[20px]"
                    rounded="full"
                    fontSize="[20px]"
                    fontWeight="bold"
                    w="[280px]"
                    [disabled]="isRetrying"
                    styleClass="relative group overflow-hidden transition-all duration-300 ease-out justify-center items-center font-archivo mx-auto line-height-[29px] tracking-[0.5px]"
                    (onClick)="retry()">
                </NiButton>
                
                <NiButton 
                    label="Go to Home" 
                    bg="transparent"
                    text="primary-500"
                    hoverBg="primary-50"
                    px="[24px]"
                    py="[20px]"
                    rounded="full"
                    fontSize="[18px]"
                    fontWeight="medium"
                    w="[280px]"
                    [disabled]="isRetrying"
                    styleClass="relative group overflow-hidden transition-all duration-300 ease-out justify-center items-center font-archivo mx-auto line-height-[29px] tracking-[0.5px] border-2 border-primary-500"
                    (onClick)="goHome()">
                </NiButton>
            </div>
    
            <!-- Additional Help Text -->
            <div class="mt-[8px]">
                <p class="text-[#888] font-['archivo'] text-[14px] leading-[20px] text-center">
                    If the problem persists, please contact support.
                </p>
            </div>
        </div>
    </div>
</div>

